module.exports = __webpack_public_path__ + "img/21_5.b128e35d.png";